const getLocationInfo = async (address) =>
  fetch(
    `https://api.opencagedata.com/geocode/v1/json?q=${address}&key=1ac131464b584432a1136d944619b5d9`
  )
    .then((response) => response.json())
    .then((data) => data);

export { getLocationInfo };
